/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { parameterForceRequote } from 'pu-data/Utils';
import { ERROR, QUOTED, PRICE_SELECTED, START } from 'pu-data/QuoteSteps';
import SimpleReactValidator from 'pu-utils/simple-react-validator';

import defaultState from './data/defaultState';
import initialState from './data/initialState';

//import { basicParams, validateParametersRules, aditionalRules, extraValidationRules } from './data/Utils'
import SupplierTypes from './data/supplierTypes';

import { changeParameterByName } from './slice/onChangeParameter';
import { calculateRailWidths, mustUpdatePanelSize, updatePanelSize } from './slice/panelize';
import { requireCustomQuote } from './slice/crossNeedCustomQuote';

import { changeTab } from 'product_tabs/tabs/tabSlice';
import { TAB_FABRICATION } from 'product_tabs/tabs/data/tabType';
import { showErrors } from 'product_tabs/alerts/alertSlice';

import { changeGlobalParameter } from 'product_tabs/actions';
import { isParameterNameQtyValid, isProductTypeParameterNameQtyValid } from 'pu-utils/validate';

import { getQuote, emailQuote, emailQuoteRequest } from 'api/apiQuote';

export const doQuote = createAsyncThunk(
  'fabrication/doQuote',
  async (args, thunkAPI) => {
    const state = thunkAPI.getState().fabrication;
    const { parameters, suppliers } = state;

    const token = document.getElementsByName('authenticity_token')[0].value;
    const variant = document.getElementsByName('variant_id')[0].value;

    const data = {};
    suppliers.forEach((s) => {
      data[s] = parameters;
    });

    const promise = getQuote({
      data, token, variant, quoteNumber: parameters.product_quote_number,
    });

    return promise
      .then((res) => res.data)
      .catch((error) => thunkAPI.rejectWithValue({ error: error.message }));
  },
);

export const doEmailQuote = createAsyncThunk('fabrication/doEmailQuote', async (args, thunkAPI) => {
  const { data, token } = args;
  const promise = emailQuote({ data, token });
  return promise
    .then((res) => res.data)
    .catch((error) => thunkAPI.rejectWithValue({ error: error.message }));
});

export const doEmailQuoteRequest = createAsyncThunk('fabrication/doEmailQuoteRequest', async (args, thunkAPI) => {
  const state = thunkAPI.getState().fabrication;
  const { parameters } = state;

  const token = document.getElementsByName('authenticity_token')[0].value;
  const variant = document.getElementsByName('variant_id')[0].value;

  let form = new FormData();
  form.append('authenticity_token', token);
  form.append('variant_id', variant);
  Object.keys(parameters).forEach((key) => {
    form.append(`parameters[${key}]`, parameters[key]);
  });
  const inputFile = $('#gerber-file')
  const file = inputFile ? inputFile.prop('files')[0] : null
  if (file) form.append('parameters[filename]', file)
  
  const promise = emailQuoteRequest(form);
  return promise
    .then((res) => res.data)
    .catch((error) => thunkAPI.rejectWithValue({ error: error.message }));
})

export const validator = new SimpleReactValidator({});

export const validatorProject = new SimpleReactValidator({});

const fabricationService = createSlice({
  name: 'fabricationService',
  initialState: {
    ...initialState,
    validatorFlag: false,
  },
  reducers: {
    changeParameter(state, action) {
      const { name, value } = action.payload
      changeParameterByName(state.parameters, name, value);
      calculateRailWidths(state.parameters);
      if (mustUpdatePanelSize(state.parameters, name)) {
        updatePanelSize(state.parameters);
      }

      if (isParameterNameQtyValid(name)) {
        if (!state.quantitiesChanged) {
          state.quantitiesChanged = true
        }

        if (state.quote.line_items.length > 0 && state.quoteStep == START) {
          const qty_index = Number(name.split('qty')[1]) - 1
          state.quote.line_items.forEach(li => li['quantities'][qty_index] = value)
        }
      }

      state.parametersChanged = parameterForceRequote(name);
      state.needCustomQuote = requireCustomQuote(state.parameters);
    },
    priceSelected(state, action) {
      const sp = action.payload;
      state.parameters.row_selected = sp.row_selected;
      state.parameters.column_selected = sp.column_selected;
      state.parameters.quote_config_key = sp.quote_config_key;
      state.parameters.supplier_selected = sp.supplier;
      state.parameters.vendor_selected = sp.supplier;

      state.quoteStep = PRICE_SELECTED
    },
    deleteFabrication(state) {
      const { part_number, revision, filename } = state.parameters;
      validator.hideMessages();
      const newState = _.cloneDeep({ ...defaultState, validatorFlag: false });
      newState.parameters.part_number = part_number;
      newState.parameters.revision = revision;
      newState.parameters.filename = filename;
      newState.lineItemId = state.lineItemId;
      newState.destroy = true;
      return newState;
    },
    updateCustomQuoteRequest(state, action){
      state.customQuoteRequest = action.payload;
    },
    updateValidatorFlag(state) {
      // validator.showMessages();
      // validatorProject.showMessages();
      state.validatorFlag = !state.validatorFlag;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(changeGlobalParameter, (state, action) => {
        const { name, value } = action.payload
        if(isProductTypeParameterNameQtyValid(name, 'assembly') && !state.quantitiesChanged && state.quoteStep == START) {
          const qty_index = Number(name.split('_qty')[1]) - 1
          state.parameters.quantities[qty_index] = value
        }
      })
      .addCase(doQuote.pending, (state) => {
        state.loading = true;
      })
      .addCase(doQuote.fulfilled, (state, action) => {
        const quote = action.payload;
        state.quote = quote;
        state.loading = false;
        state.parametersChanged = false;
        state.parameters.product_quote_number = quote.number;
        state.parameters.row_selected = '';
        state.parameters.column_selected = '';
        state.parameters.quote_config_key = '';
        state.parameters.supplier_selected = '';
        state.parameters.vendor_selected = '';
      })
      .addCase(doQuote.rejected, (state) => {
        state.loading = false;
        state.quoteStep = ERROR;
        state.quote = {}
        state.usGroups = [];
        state.usCombined = {};
      })
      .addCase(doEmailQuote.pending, (state) => {
        state.loading = true;
      })
      .addCase(doEmailQuote.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(doEmailQuote.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(doEmailQuoteRequest.pending, (state) => {
        state.loading = true;
      })
      .addCase(doEmailQuoteRequest.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(doEmailQuoteRequest.rejected, (state) => {
        state.loading = false;
      })
  },
});

export const {
  changeParameter,
  priceSelected,
  updateCustomQuoteRequest,
  updateValidatorFlag,
  deleteFabrication,
} = fabricationService.actions

export default fabricationService.reducer;

export const checkFabricationForErrors = (fabrication) => {
  if (!fabrication) return false;
  const {
    parametersCustomer: parameters,
  } = fabrication;

  if (!validatorProject.allValid()) {
    validatorProject.showMessages();
    const { part_number, revision } = parameters;
    if (!part_number || part_number.length <= 0 || !revision || revision.length <= 0) return 'Please fill the part number and revision before proceeding.'
    return 'Please upload a zip file with your gerber and bom files before proceeding.'
  }

  return '';
}

export const getFabricationFundamentalData = (fabrication) => {
  if (!fabrication || !fabrication.parameters) return { quantities: [] }
  const { parametersCustomer: parameters } = fabrication;
  const { quantities } = parameters;
  return { quantities }
}

export const validate = () => (dispatch, getState) => {
  const { quoteStep, parametersChanged } = getState().fabrication;

  let validateResult = true;

  
  if (quoteStep === PRICE_SELECTED) {
    if (!validator.allValid()) {
      validator.showMessages();
      dispatch(updateValidatorFlag());
      dispatch(changeTab(TAB_FABRICATION));
      dispatch(showErrors('Please fix the errors in Fabrication form'));
      validateResult = false;
      setTimeout(() => {
        document.querySelector('.pcb-fabrication .srv-validation-message').scrollIntoView(false);
      }, 500);
    } else {
      if (parametersChanged) {
        dispatch(showErrors('One or more parameters have changed. Please get a new Fabrication quote'));
        dispatch(changeTab(TAB_FABRICATION));
        validateResult = false;
      }
    }
  }

  if (!validatorProject.allValid()) {
    validatorProject.showMessages();
    let errors = validatorProject.getErrorMessages();
    let foundErrors = [];
    if(errors['Part Number'] && errors['Part Number'] != "") foundErrors.push('Please enter the part number for your project.');
    if(errors['Revision'] && errors['Revision'] != "") foundErrors.push('Please enter your revision.');
    if(errors['Zip file'] && errors['Zip file'] != "") foundErrors.push('Please upload your Zip File');
    dispatch(showErrors(foundErrors));
    dispatch(updateValidatorFlag());
    validateResult = false;
    setTimeout(() => {
      document.querySelector('.project-information .srv-validation-message').scrollIntoView(false);
    }, 500);
  }
  
  return validateResult;
}